import { defineMessages } from 'react-intl'

export default defineMessages({
  dateCreated: {
    id: 'OrganizationSettings.Spaces.DateCreated',
    defaultMessage: 'Date Created'
  },
  default: {
    id: 'OrganizationSettings.Spaces.Default',
    defaultMessage: 'Default'
  },
  deletingSpace: {
    id: 'OrganizationSettings.Spaces.DeletingSpace',
    defaultMessage: 'Deleting space'
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  noSpaces: {
    id: 'OrganizationSettings.Spaces.NoSpaces',
    defaultMessage: 'Currently there are no spaces in the organization'
  },
  spacesLowerCase: {
    id: 'spaces',
    defaultMessage: 'spaces'
  },
  unableToDelete: {
    id: 'OrganizationSettings.Spaces.UnableToDelete',
    defaultMessage: 'Unable to delete'
  },
  unableToDeleteDesc: {
    id: 'OrganizationSettings.Spaces.UnableToDeleteSubMessage',
    defaultMessage:
      'You can not delete the default space.  Please assign a new default space before deleting this space'
  },
  yes: {
    id: 'Yes',
    defaultMessage: 'Yes'
  },
  defaultSpace: {
    id: 'Default',
    defaultMessage: 'Default'
  }
})
